function changePrintLink() {
	var optionsSelects = $(".js-options-select");
	var printButtons = $(".js-print-link");
	var link = printButtons.attr("data-print-link");
	var parameters = {};
	
	$.each(optionsSelects, function(ind, val) {

		var name = $(val).attr("name");
		var value = $(val).val();

		parameters[name] = value;

	});

	var parameterKeys = Object.keys(parameters);
	var queryString = "";

	for (var i = 0, len = parameterKeys.length; i < len; i++)
	{
		queryString += "&" + parameterKeys[i] + "=" + parameters[parameterKeys[i]];
	}

	if (queryString) {
		queryString = "?" + queryString.substring(1);
	}

	printButtons.data("href", link + queryString);;
}

function changeLeasingPrice() {

	var optionsSelects = $(".js-options-select");
	var productPrice = $(".js-product-price");
	var productOldPrice = $(".js-product-old-price");
	var optionsPrice = 0;
	
	$.each(optionsSelects, function(ind, val) {

		var selectedOption = $(this).find("option:selected");

		if (selectedOption.attr("data-price")) {
			optionsPrice += parseFloat(selectedOption.attr("data-price"), 10);
		}

	});

	var totalPrice = parseFloat(productPrice.attr("data-price"), 10) + optionsPrice;
	var totalOldPrice = parseFloat(productOldPrice.attr("data-old-price"), 10) + optionsPrice;
	
	productPrice.text(
		totalPrice.toFixed(2)
	);

	productOldPrice.text(
		totalOldPrice.toFixed(2)
	);

	$("#popup-leasing product-leasing").attr(":price", totalPrice);

}

$(document).on("change", ".js-options-select", function() {

	changePrintLink();
	changeLeasingPrice();

});

$(".js-print-link").on("click", function(e) {

	if ($(window).width() >= 1024)
	{
		e.preventDefault();

		window.open(
			$(this).data("href"), 
			"_blank", 
			"width=1024,height=640,toolbar=no,status=no,resizeable=yes,menubar=no,scrollbars=yes"
		);
	}
	else if (/ip(hone|od)|ipad/i.test(navigator.userAgent) || navigator.userAgent.toLowerCase().indexOf("android") > -1)
	{
		window.open($(".js-print-link").attr("data-print-link"), "_blank");
	}

});

// Add listener
var timer = null;
CartItems.on("add", function(item) {
	
	clearTimeout(timer);
    $(document.body).addClass("cart-item-added");

    timer = setTimeout(function() {
        $(document.body).removeClass("cart-item-added");
    }, 1000);

});



$(".js-add-to-cart").on("click", function(e) {
	e.preventDefault();
	
	var productEl = $(this).closest(".product");
	var product = JSON.parse(productEl.attr("data-product"));

	var optionsSelects = productEl.find(".js-options-select");
	var options = [];
	
	$.each(optionsSelects, function(ind, val) {

		var selectedOption = $(val).find("option:selected");

		if (selectedOption.attr("data-option")) {
			options.push(JSON.parse(selectedOption.attr("data-option")));
		}

	});

	product.selectedOptions = options;
	CartItems.add(product);

});

var compareTimer = null;
var tooltip = $('.btn-compare__tooltip');
CompareItems.on("add", function(item) {
	
	clearTimeout(compareTimer);
	
	$(document.body).addClass("compare-item-added");
	tooltip.each(function(i,e) {
		if($(e).data('id') == item.id) {
			compareTimer = setTimeout(function() {
				$(e).text('Премахни от сравнение');
				$(document.body).removeClass("compare-item-added");
			}, 100);
			
		}
	});

    compareTimer = setTimeout(function() {
        $(document.body).removeClass("compare-item-added");
    }, 1000);

});

// CompareItems.on("remove", function(item) {
	
// 	clearTimeout(compareTimer);
// 	$(document.body).addClass("compare-item-removed");
// 	$('.compare-tooltip').text('Продуктът е премахнат от сравнение');
//     compareTimer = setTimeout(function() {
//         $(document.body).removeClass("compare-item-removed");
//     }, 100);

// });

function addToCompare(el) 
{
	try {
			
		if(el.parents().hasClass("product-card")) {
			
			var cardData = JSON.parse($(this).attr('data-product'));
			cardData.isIndex = true;
			CompareItems.add(cardData);
			el.removeClass('js-data-add-to-compare').addClass('js-remove-compare-item');
		} else {
			el = JSON.parse($(".product").attr('data-product'));
			CompareItems.add(el);
		}
	}
	catch (e) {
		var message = {
			type: "error",
			title: "Грешка",
			message: "Възникна грешка. Моля, опитайте отново"
		};

		if (e === "DIFFERENT_CATEGORY") {
			message["message"] = "Можете да добавяте за сравнение само продукти от една и съща категория.";
		}

		if (e === "PRODUCT_ALLREADY_EXISTS") {
			message["message"] = "Продуктът вече е добавен в списъка за сравнение.";
		}

		if (e === "LIMIT_EXCEEDED") {
			message["message"] = "Максималния допустим брой за продукти за сравнение е 3.";
		}

		Popup.showMessage(message);

	}
}

var tooltip = $('.btn-compare__tooltip');

window.addRemoveToCompare = function(e) {
	e.stopImmediatePropagation();
	e.preventDefault();

	if ($(this).hasClass("js-data-add-to-compare")) {
		addToCompare.call(this, $(this));
	} else {
		var _this = $(this);
		var id = _this.attr("data-id");
		var index = -1;
		var items = CompareItems.items;
		
		for (var i = 0, len = items.length; i < len; i++) {
			if (items[i].id == id) {
				index = i;
				break;
			}
		}
		CompareItems.remove(index, _this.parent().hasClass('product__compare'));

		_this.removeClass('js-remove-compare-item').addClass('js-data-add-to-compare');

		tooltip.each(function(i,e) {
			if($(e).data('id') == _this.data('id')) {
				compareTimer = setTimeout(function() {
					$(e).text('Добави за сравнение');
				}, 100);
				
			}
		});
	}
	
}

$(".link__product-card").on("click", ".product__compare .btn-compare", addRemoveToCompare);

$(".inner-compare-btn").on("click", function(e) {
	e.preventDefault();
	addToCompare.call(this, $(this));
});

// $(document).ready(function() {
	
// 	(function() {
		
// 		var element = $('.product__compare .product');
// 		if(CompareItems.items.length > 0) {
// 			element.each(function(i,el) {
				
// 				CompareItems.items.forEach(e => {
// 					if($(el).data('id') == e.id){
// 						$(el).addClass('js-remove-compare-item');

// 						tooltip.each(function(i,e) {
// 							if($(e).data('id') == $(el).data('id')) {
// 								$(e).text('Премахни от сравнение');
// 							}
// 						});
						
// 					} 
// 					else if(!$(el).hasClass('js-remove-compare-item')){
// 						$(el).addClass('js-data-add-to-compare');
// 					}
// 				});
// 			});
// 		} else {
// 			element.addClass('js-data-add-to-compare');
// 		}
		
// 	})();
// });